// extracted by mini-css-extract-plugin
export const contentWrapper = "blog-post-module--content-wrapper--1Fa82";